import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { TraNhanVay } from "./TraNhanVay";

export const BtnTraNhanVay = ({ item ,quyenSuaTienTatToan}) => {
  console.log(item, "ds");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Trả huy động vốn"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <span className="tat-toan-button"></span>
        </PopoversBootrap>
      </a>
      {show && (
        <TraNhanVay
          show={show}
          onHide={handleClose}
          NhanVayId={item.ID}
          NguoiNhan={item.TenChuNo}
          item={item}
          quyenSuaTienTatToan={quyenSuaTienTatToan}
        />
      )}
    </>
  );
};
